/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Photo_AddInputs */

const en_directory_ai_tools_studio_photo_add = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to add a clear selfie`)
};

const zh_directory_ai_tools_studio_photo_add = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击添加一张清晰自拍`)
};

/**
* | output |
* | --- |
* | "Tap to add a clear selfie" |
*
* @param {Directory_Ai_Tools_Studio_Photo_AddInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_photo_add = /** @type {((inputs?: Directory_Ai_Tools_Studio_Photo_AddInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Photo_AddInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_photo_add(inputs)
	return zh_directory_ai_tools_studio_photo_add(inputs)
});
export { directory_ai_tools_studio_photo_add as "directory.ai_tools.studio.photo_add" }